import { getLabel } from '../labels/labelling-service';
import logger from '../services/logging/logging-service';

import { forEach } from './array-utils';
import { isDOMElement, observeNodeMutation } from './dom-utils';

const injectAdvLabel = ($advNode) => {
  const $labelNode = document.createElement('div');
  $labelNode.className = 'c-label--advertisement';
  const $labelText = document.createTextNode(getLabel('global.advertisement'));
  $labelNode.appendChild($labelText);
  // Append label as first child
  $advNode.insertBefore($labelNode, $advNode.firstChild);
  $advNode.dataset.labelled = 'true';
};

const shouldInjectLabel = ($advNode) => {
  if (!isDOMElement($advNode)) {
    logger.error('[ADV] $advNode is not a DOM element');
    return;
  }
  const height = parseInt(window.getComputedStyle($advNode).height, 10);
  const isLabelled = $advNode.dataset.labelled === 'true';
  return !isLabelled && height > 150;
};

const getAdvLabelObserverCallback = ($advNode) => (_mutationsList, mutationObserver) => {
  // Add a delay to improve the height calculation realiability
  setTimeout(() => {
    if (shouldInjectLabel($advNode)) {
      mutationObserver.disconnect();
      injectAdvLabel($advNode);
    }
  }, 300);
};

/**
 * Observe the adv containers and add labels right after the adv injection
 */
export const initAdvLabels = () => {
  const $advNodes = document.querySelectorAll('.c-adv');

  forEach(($advNode) => {
    if ($advNode.dataset.observed !== 'true') {
      $advNode.dataset.observed = 'true';
      const mutationsConfig = { attributes: false, childList: true, subtree: true };
      observeNodeMutation({ $targetNode: $advNode, callback: getAdvLabelObserverCallback($advNode), mutationsConfig });
    }
  })($advNodes);

  // After 10 sec check again the possible adv's not labelled (i.es. when you open a page in a new tab the observer does not work)
  setTimeout(() => {
    const $advNodesNotLabelled = document.querySelectorAll('.c-adv:not([data-labelled="true"])');
    forEach(($advNode) => {
      if (shouldInjectLabel($advNode)) {
        injectAdvLabel($advNode);
      }
    })($advNodesNotLabelled);
  }, 10000);
};
